import React from 'react';

const LogRow = ( props ) => {
  const { exercise, headers } = props;

  const renderRow = () => {
    const columns = headers.map(header => {
      const answer = (exercise.answer[header.field].value !== '' ? exercise.answer[header.field].value : '-')
      return (<td className={`text-center ${exercise.answer[header.field]?.className}`} style={{fontSize: 16}} name={header.field}>{answer}</td>);
    });

    columns.push(<td></td>);
    return columns;
  }

  return (
    <tr>
      {renderRow()}
    </tr>
  );
}

export default (LogRow);
